import { createStore } from 'vuex';
import auth from './modules/auth';
import trips from './modules/trips';
import reviews from './modules/reviews';
import users from './modules/users';

export default createStore({
  modules: {
    auth,
    trips,
    reviews,
    users
  },
  state: {
    loading: false,
    sidebarCollapsed: false
  },
  mutations: {
    SET_LOADING(state, status) {
      state.loading = status;
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    SET_SIDEBAR_COLLAPSED(state, status) {
      state.sidebarCollapsed = status;
    }
  },
  actions: {
    setLoading({ commit }, status) {
      commit('SET_LOADING', status);
    },
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR');
    },
    setSidebarCollapsed({ commit }, status) {
      commit('SET_SIDEBAR_COLLAPSED', status);
    }
  },
  getters: {
    isLoading: state => state.loading,
    isSidebarCollapsed: state => state.sidebarCollapsed
  }
});
